import { render, staticRenderFns } from "./StatsCardV2.vue?vue&type=template&id=56e485b8"
import script from "./StatsCardV2.vue?vue&type=script&lang=js"
export * from "./StatsCardV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports